import React from 'react';
import { TouchableOpacity } from 'react-native-gesture-handler';

import { Text, TextProps } from '@/components/TextComponent';
import { Row, RowProps } from '@/components/lib/components';
import { common } from '@/styles/styles';

export type BannerProps = {
    textVariant?: TextProps['variant'];
    backgroundColor?: RowProps['backgroundColor'];
    textColor?: TextProps['color'];
    borderColor?: RowProps['borderColor'];
    borderWidth?: RowProps['borderWidth'];
    leftIcon?: React.JSX.Element;
    rightIcon?: React.JSX.Element;
    message: string | React.JSX.Element;
    onPress?: () => void;
    testID?: string;
    style?: RowProps['style'];
};

export const Banner = ({
    textVariant = 'bodySmall',
    backgroundColor = 'neutral700',
    textColor,
    borderColor,
    borderWidth = 0,
    leftIcon,
    rightIcon,
    message,
    onPress,
    testID,
    style,
}: BannerProps) => {
    const rowElement = (
        <Row
            padding="s16"
            gap="s16"
            borderRadius="r16"
            backgroundColor={backgroundColor}
            alignItems="center"
            borderColor={borderColor}
            borderWidth={borderWidth}
            style={style}
        >
            {leftIcon}

            <Text variant={textVariant} color={textColor} style={common.flex} testID={`betSummaryError-${testID}`}>
                {message}
            </Text>

            {rightIcon}
        </Row>
    );
    return onPress ? <TouchableOpacity onPress={onPress}>{rowElement}</TouchableOpacity> : rowElement;
};
